import * as React from 'react'

export function cmdCtrlKey(event:KeyboardEvent | React.KeyboardEvent) {
  return event.metaKey || event.ctrlKey;
}
